/* eslint-disable sonarjs/cognitive-complexity */
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { isFindPage, showArrows } from '../../helpers/find';
import ThemeContext from '../../providers/ThemeProvider';

const NavigationLinks = ({
  isMobile = false,
  navigations,
  recommendation = false,
  url = null,
}) => {
  const theme = useContext(ThemeContext);
  useEffect(() => {
    const container = document.querySelector(
      recommendation
        ? '#recommendation-scrollable-container'
        : '#scrollable-container',
    );
    const scrollLeftButton = document.querySelector(
      recommendation ? '#recommendation-scroll-left' : '#scroll-left',
    );
    const scrollRightButton = document.querySelector(
      recommendation ? '#recommendation-scroll-right' : '#scroll-right',
    );

    scrollLeftButton?.addEventListener('click', () => {
      container.scrollBy({ behavior: 'smooth', left: -280 });
    });

    scrollRightButton?.addEventListener('click', () => {
      container.scrollBy({ behavior: 'smooth', left: 280 });
    });
  }, []);

  const showArrow = showArrows({ isMobile, navigations, recommendation });

  return (
    <>
      <div className="container">
        {showArrow && (
          <div
            className="scroll-arrow  scroll-arrow--left left"
            id={recommendation ? 'recommendation-scroll-left' : 'scroll-left'}
          >
            <FontAwesomeIcon className="arrow-left" icon={faChevronLeft} />
          </div>
        )}
        <div
          className="links__container"
          id={
            recommendation
              ? 'recommendation-scrollable-container'
              : 'scrollable-container'
          }
        >
          {navigations.map((item) => {
            return (
              <a
                className="links__item"
                href={item.url.replace(
                  'national-deal',
                  isFindPage(url) ? 'deals/shop' : 'find/shop',
                )}
                key={item.id}
              >
                <div className="links__text">
                  {recommendation ? item.displayName : item.linkText}
                </div>
              </a>
            );
          })}
        </div>
        {showArrow && (
          <div
            className="scroll-arrow  scroll-arrow--right right"
            id={recommendation ? 'recommendation-scroll-right' : 'scroll-right'}
          >
            <FontAwesomeIcon className="arrow-right" icon={faChevronRight} />
          </div>
        )}
      </div>
      <style jsx>{`
        ::-webkit-scrollbar {
          width: 0px;
        }
        .container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          padding: 4px;
        }
        .links__container {
          align-items: center;
          display: flex;
          font-size: ${isMobile ? '12px' : '14px'};
          font-weight: bold;
          justify-content: flex-start;
          margin: ${!showArrow && !isMobile ? '0 18px' : '0'};
          overflow-x: auto;
          width: 100%;
        }
        .links__item {
          align-items: center;
          border: ${recommendation
            ? ` 1px solid ${theme.colors.searchborder} `
            : ` 1px solid ${theme.colors.searchborderfocused}`};
          border-radius: 10px;
          color: ${recommendation ? '#333' : '#000'};
          cursor: pointer;
          display: flex;
          flex: ${isMobile ? '0 0 49%' : '0 0 24.5%'};
          height: 60px;
          justify-content: center;
          margin: 2px;
          max-width: ${isMobile ? '49%' : '24.5%'};
          min-width: ${isMobile ? '49%' : '24.5%'};
          text-align: center;
        }
        .links__item:hover {
          background: ${recommendation ? '#ffebf7' : '#e2e2e2'};
          border: ${recommendation
            ? ` 3px solid ${theme.colors.searchborder} `
            : ` 3px solid ${theme.colors.searchborderfocused}`};
          text-decoration: none;
        }
        .links__text {
          display: inline-block;
          margin: 5px;
          word-break: break-word;
        }
        .scroll-arrow {
          border: none;
          align-items: center;
          z-index: 101;
          color: ${theme.colors.arrowbackground};
        }
        .scroll-arrow--left {
          left: 0;
          background-image: linear-gradient(
            to left,
            white 25%,
            rgba(255, 255, 255, 0)
          );
          justify-content: flex-start;
          padding: 0 10px 10px 0;
        }
        .scroll-arrow--right {
          right: 10;
          background-image: linear-gradient(
            to left,
            white 25%,
            rgba(255, 255, 255, 0)
          );
          justify-content: flex-end;
          padding: 0 0 10px 10px;
        }
        @media (max-width: 767.98px) {
          .container {
            padding: 0;
            overflow: auto;
          }
          .scroll-arrow {
            transition: opacity 0.2s;
          }
        }
      `}</style>
    </>
  );
};

NavigationLinks.propTypes = {
  isMobile: PropTypes.bool,
  navigations: PropTypes.array,
  recommendation: PropTypes.bool,
  url: PropTypes.string,
};

export default NavigationLinks;
